import { AddressType } from "@onsip/common/services/api/apiResponseHelpers";

export interface ApiRecManagement {
  Pin: string;
  Address: {
    AddressId: string;
    Domain: string;
    Name: string;
    Type: AddressType;
    Username: string;
  };
}

export interface RecManagement {
  pin: string;
  addressId: string;
  name: string;
  username: string;
  domain: string;
  type: AddressType;
}

export function apiRecManagerToRecManager(apiRecManagement: ApiRecManagement): RecManagement {
  return {
    pin: apiRecManagement.Pin,
    addressId: apiRecManagement.Address.AddressId,
    name: apiRecManagement.Address.Name,
    username: apiRecManagement.Address.Username,
    domain: apiRecManagement.Address.Domain,
    type: apiRecManagement.Address.Type
  };
}

export interface RecManagementParams {
  Address: string;
  Pin: number;
  Name: string;
  Username: string;
}
